/* eslint-disable import/prefer-default-export */

import React, { useRef } from 'react'
import IsVisible from 'react-is-visible'
import { Fade } from 'react-reveal'
import { useContainerDimensions } from '../../hooks'
import './About.css'
import { langs } from '../../portfolio'

const Languages = () => {
  const skillsWrapper = useRef()
  const { width } = useContainerDimensions(skillsWrapper)

  return (
    <section className='section' id='skills_section'>
      <h2 className='section__title'>Languages</h2>      
      <Fade duration={1000}>
        <div style={{ position: 'relative', width: '100%'}}>
          <IsVisible once>
            {(isVisibleSkillsWrapper) => (
              <div
                className="skills-wrapper"
                style={
                  isVisibleSkillsWrapper
                    ? {
                        transition: '1s opacity ease-in-out',
                        transform: `translateX(0)`,
                        opacity: 1,
                      }
                    : {}
                }
              >
                <ul className="skills" ref={skillsWrapper}>
                  {langs.map((lang) =>
                      <li className="skill-bar-wrapper skills__list-item" key={lang.skillName}>
                        <div
                          className="skill-bar"
                          style={
                            isVisibleSkillsWrapper
                              ? {
                                  transition: `${
                                    1 + lang.id / 10
                                  }s width ease-in-out`,
                                  width: width * (lang.amount / 100),
                                }
                              : {
                                  width: 1,
                                }
                          }
                        ></div>
                        <div className="skill-name">{lang.langName}</div>
                      </li>
                  )}
                </ul>
              </div>
            )}
          </IsVisible>
        </div>
      </Fade>
    </section>
  )
}

export default Languages
